// @flow

import React from 'react';
import { compose, setDisplayName } from 'recompose';
import {
  injectSheet,
  type InjectSheetProvidedProps,
  type ThemeType
} from '@catalytic/catalytic-ui';
import logoUrl from '../images/logo.svg';
import classNames from 'classnames';

export const Style = (theme: ThemeType) => ({
  root: {
    height: '3rem',
    marginBottom: '2rem',
    [theme.breakpoints.tablet]: {
      height: '4rem'
    }
  },
  embedded: {
    display: 'flex',
    flex: 'none'
  },
  image: {
    height: '100%'
  }
});

type Props = InjectSheetProvidedProps &
  HTMLImageElement & {
    isEmbedded: boolean
  };

export const WebformLogo = ({
  classes,
  src: srcProp,
  alt: altProp,
  isEmbedded
}: Props) => {
  const src = srcProp || logoUrl;
  const alt = !srcProp ? 'Catalytic' : altProp || '';
  return (
    <div
      className={classNames(classes.root, {
        [classes.embedded]: isEmbedded
      })}
    >
      <img
        data-testid="webform-logo"
        className={classes.image}
        src={src}
        alt={alt}
      />
    </div>
  );
};
WebformLogo.displayName = 'WebformLogo';

export default compose(
  injectSheet(Style),
  setDisplayName('WebformLogo')
)(WebformLogo);
